import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Vue from 'vue'

const state = {
	active: false,

  // form
  serviceId: null,
  serviceContentsId: null,

  // model
  contentsApplyModel: [],
  
  // データ更新の判別フラグ
  updated: false
}

const getters = {
	get: state => state,

  // form mode
  isRegister: state => state.targetId === Constants.RegisterHash,
  isModify: state => state.targetId !== Constants.RegisterHash,
}

const actions = {
  show ({commit}, {serviceId, serviceContentsId}) {
    // 新規作成の場合「Constants.RegisterHash」
    // コピーの場合「NoticeId」が引き渡される
    commit('setServiceId', serviceId)
    commit('setServiceContentsId', serviceContentsId)

		// cover
		this.dispatch('core/showModalCover')
		
		commit('showed')
	},
	hide ({commit}) {
		if (!state.active) return
		commit('hided')
		
		// cover
		setTimeout(() => {
			this.dispatch('core/hideModalCover')
		}, 350)
  },

  /**
   * 初期データを読出し
   */
  loadModel ({commit}, {contentsApplyParams}) {
    return new Promise((resolve, reject) => {
      ApiManager.request(
        ['serviceContentsApply'],
        ['v1ServiceContentsApplyListGet'],
        [contentsApplyParams])
        .then(res => {
          let status = Utility.parseResponse(res)

          if (status.result) {
            commit('setContentsApplyModel', res[0].data.serviceAppliedContents)
            console.log('contentsApplyModel', state.contentsApplyModel)
            resolve()

          } else if (status.error) {
            // エラーメッセージ表示
            reject(res)
          } else {
            // アプリケーションエラー表示
            reject(null)
          }
        })
        .catch(error => {
          // アプリケーションエラー表示
          reject(null)
        })
    })
  },

  /**
   * データ更新判別フラグの切替
   */
  setUpdated ({commit}, flag) {
    commit('setUpdated', flag)
  },
}

const mutations = {
	showed (state) {
		state.active = true
	},
	hided (state) {
    state.active = false
	},

  setServiceId (state, id) {
    state.serviceId = id
  },
  setServiceContentsId (state, id) {
    state.serviceContentsId = id
  },

  setContentsApplyModel (state, data) {
    data.sort(Utility.sortByKey('priorityOrder', true))
    Vue.set(state, 'contentsApplyModel', data)
  },

  // updated
  setUpdated (state, flag) {
    state.updated = flag
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
